// extracted by mini-css-extract-plugin
export default {"mainbutton":"input-mainbutton_mainbutton__xAlys","disabled":"input-mainbutton_disabled__HKcAj"};